import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const DigitalMarketingJobsGurugram = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Digital Marketing Jobs in Gurugram | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest digital marketing jobs in Gurugram NCR. Explore openings for SEO, SEM, social media, and content marketing professionals. Apply for fresher and experienced roles in top companies."
        />
        <meta
          name="keywords"
          content="digital marketing jobs in gurugram, SEO jobs in gurugram, social media marketing jobs in gurugram, SEM jobs in gurugram NCR, content marketing jobs gurugram, PPC jobs in gurugram, online marketing jobs gurugram, digital marketing executive jobs gurugram, fresher digital marketing jobs gurugram"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/digitalmarketing-jobs-in-gurugram"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Digital Marketing Jobs in Gurugram – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for <strong>digital marketing jobs in Gurugram</strong>? Explore
          hundreds of openings in SEO, social media, PPC, and content marketing.
          Whether you’re a fresher or an experienced professional, discover{" "}
          <strong>digital marketing executive</strong> and{" "}
          <strong>manager-level roles</strong> in Gurugram NCR today.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Digital Marketers in Gurugram
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Webchutney</li>
          <li>WATConsult</li>
          <li>AdGlobal360</li>
          <li>iProspect India</li>
          <li>Techmagnate</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular Job Roles in Digital Marketing
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>SEO Executive Jobs in Gurugram</li>
          <li>Social Media Manager Jobs in Gurugram</li>
          <li>PPC Specialist Jobs in Gurugram</li>
          <li>Content Marketing Jobs in Gurugram</li>
          <li>Email Marketing Jobs in Gurugram</li>
          <li>Digital Marketing Analyst Jobs in Gurugram</li>
          <li>Google Ads Expert Jobs in Gurugram</li>
          <li>Digital Marketing Internships in Gurugram</li>
          <li>Performance Marketing Jobs in Gurugram</li>
          <li>Freelance Digital Marketing Jobs in Gurugram</li>
        </ul>

        <p className="text-gray-600">
          Start your journey in the digital world with{" "}
          <strong>jobsindelhincr.in</strong> — your trusted job portal to find
          verified <strong>digital marketing job openings</strong> in Gurugram.
          No registration required — apply directly to top companies today!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default DigitalMarketingJobsGurugram;
